import React from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import { useIntl } from 'react-intl';
import { useQuery } from '@apollo/client';

import useInsuranceInfo from '../../../hooks/useInsuranceInfo';
import { getMenuLinksConfig } from '../navMenuUtils';
import {
  GET_CUSTOMER,
  DA_DIREKT_POLICY_CATEGORIES,
  RISK_CARRIER_AMTRUST,
  SPECIAL_TARIFF_POLICY_CATEGORIES,
} from '../../../shared';
import { myProfileLinkItems, helpLinkItems } from '../navMenuConfig';

import ExternalLinkIcon from '../../../icons/ExternalLinkIcon';
import NavLinkDropdown from './NavLinkDropdown';

import {
  StyledNavMenuDesktop,
  StyledNavMenuDesktopList,
  StyledNavMenuItemDesktopLink,
} from './NavMenuDesktop.styled';

function NavMenuDesktop() {
  const { data: customerData } = useQuery(GET_CUSTOMER);
  const customerInsuranceCategory = customerData?.customer?.insuranceCategory;
  const customerPolicyCategory = customerData?.customer?.contract?.policyCategory;
  const location = useLocation();
  const history = useHistory();

  const intl = useIntl();

  const { type: insuranceType, isPatolo } = useInsuranceInfo();
  const isAmtrustCustomer = customerData?.customer?.contract?.riskCarrier === RISK_CARRIER_AMTRUST;

  const isDaDirektCustomer =
    Number.isInteger(customerPolicyCategory) &&
    DA_DIREKT_POLICY_CATEGORIES.includes(customerPolicyCategory);

  const isSpecialTariffCustomer =
    Number.isInteger(customerPolicyCategory) &&
    SPECIAL_TARIFF_POLICY_CATEGORIES.includes(customerPolicyCategory);

  const menuLinksConfig = getMenuLinksConfig(
    insuranceType,
    customerInsuranceCategory,
    isDaDirektCustomer,
    isAmtrustCustomer,
    isSpecialTariffCustomer,
    isPatolo
  );

  return (
    <StyledNavMenuDesktop data-nav-menu-desktop>
      <StyledNavMenuDesktopList>
        <NavLinkDropdown
          caption={intl.formatMessage({ id: 'menu.header.item.my_profile' })}
          linkItems={myProfileLinkItems(intl)}
        />

        {menuLinksConfig.map((linkItem) =>
          linkItem?.externalUrl ? (
            <li key={linkItem?.link}>
              <StyledNavMenuItemDesktopLink
                variant="h3"
                href={linkItem?.link}
                target="_blank"
                rel="noopener noreferrer"
              >
                {linkItem?.title || ''}
                <ExternalLinkIcon />
              </StyledNavMenuItemDesktopLink>
            </li>
          ) : (
            <li key={linkItem?.path}>
              <StyledNavMenuItemDesktopLink
                variant="h3"
                component="button"
                onClick={() => history.push(linkItem?.path)}
                isCurrentPage={location?.pathname?.includes?.(linkItem?.path)}
              >
                {linkItem?.title || ''}
              </StyledNavMenuItemDesktopLink>
            </li>
          )
        )}

        <NavLinkDropdown
          caption={intl.formatMessage({ id: 'menu.header.item.help' })}
          linkItems={helpLinkItems(intl, insuranceType, isPatolo)}
        />
      </StyledNavMenuDesktopList>
    </StyledNavMenuDesktop>
  );
}

export default NavMenuDesktop;
